import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "resource_library" }
const _hoisted_2 = { class: "container w-100 d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "text-primary mb-2" }, "Resource Library", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon bi-chevron-left" }, null, -1)
const _hoisted_5 = { class: "container-lg container-fluid py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Nav = _resolveComponent("Nav")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
        class: "my-3 p-button-raised p-button-text"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Back")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Nav, { navLink: _ctx.navLink }, null, 8, ["navLink"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_view)
    ])
  ]))
}